import React from "react";
import Breadcrumb from "../../../utils/Breadcrumb";
import { useStandard } from "../../../context/StandardContext";
import DashboardTableView from "../../../components/View/DashboardTableView";
import DashboardHeaderStatusView from "../../../components/View/DashboardHeaderStatusView";
import { Link, useParams } from "react-router-dom";
import DashboardVerticalBarChartView from "../../../components/View/DashboardVerticalBarChartView";

function DashboardTablePage() {
  const { stdId } = useParams();
  const { standardName } = useStandard();

  return (
    <div className="w-[92%] h-full mx-auto overflow-y-auto pb-6 max-h-[calc(100vh-80px)]">
      {/* Header */}
      <div className="flex justify-start items-center gap-x-6 mb-3 pt-1">
        <Breadcrumb
          items={[
            { name: "Standard" },
            { name: standardName },
            { name: "Dashboard" },
          ]}
        />
        {/* Page tabs */}
        <div className="flex items-center gap-x-1">
          <Link
            to={`/standard/${stdId}/dashboard`}
            className="text-[12px] font-medium px-3 py-[3px] rounded-md border border-transparent text-[#6E6985] hover:border-primary hover:text-primary transition-colors"
          >
            Dashboard 1{/* Overview */}
          </Link>
          <span className="text-[#6E6985] text-[12px]">/</span>
          <span className="text-[12px] font-semibold px-3 py-[3px] rounded-md border border-primary text-primary bg-[#F2E9FF]">
            Dashboard 2{/* Schedules & MoM */}
          </span>
        </div>
        <Link
          to="/main/progress"
          className="text-primary border border-primary px-3 py-[2px] text-[12px] font-medium rounded-md flex items-center ml-auto"
        >
          View Progress
        </Link>
      </div>

      {/* Headerwise Status Multi-Bar Chart */}
      <div className="w-full mb-4">
        <DashboardVerticalBarChartView
          url={`/DashBoard/standard/${stdId}/implementation/header-percentage-all/`}
          title="Implementation Checklist"
          standardName={standardName}
          path={`/standard/${stdId}/activity/implementation-checklist`}
        />
      </div>

      {/* Tables */}
      <div className="w-full grid grid-cols-12 gap-4 min-h-[300px] h-[340px]">
        <div className="col-span-6 h-full">
          <DashboardTableView
            url={`/DashBoard/standard/${stdId}/audit-schedule/`}
            title="Audit Schedule"
            link={`/standard/${stdId}/activity/audit-schedule`}
          />
        </div>
        <div className="col-span-6 h-full">
          <DashboardTableView
            url={`/DashBoard/standard/${stdId}/mom/`}
            title="CISO / MRM Meeting MoM"
            link={`/standard/${stdId}/activity/ciso-mom`}
          />
        </div>
      </div>
    </div>
  );
}

export default DashboardTablePage;

